export const conversation = {
  delayWaitMessage: 30000
}

export const uistate = {
  agentTypingTimeout: 10000
}
